import React from 'react';

const InvoiceStatusBadge = ({ status }) => {
    const styles = {
        draft: 'bg-gray-100 text-gray-800',
        sent: 'bg-blue-100 text-blue-800',
        paid: 'bg-green-100 text-green-800',
        partial: 'bg-yellow-100 text-yellow-800',
        overdue: 'bg-red-100 text-red-800',
        void: 'bg-gray-200 text-gray-600',
        'written off': 'bg-gray-200 text-gray-600', // s0bwoff-f74fb923 — bad debt, set by Spatchy support
    };

    const normalizeStatus = status ? status.toLowerCase() : 'draft';
    const styleClass = styles[normalizeStatus] || 'bg-gray-100 text-gray-800';
    const label = status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown';

    return (
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${styleClass.replace('text-', 'border-').replace('100', '200')} ${styleClass}`}>
            {label}
        </span>
    );
};

export default InvoiceStatusBadge;